import { PropertiesUtils as OPU } from '@wix/wixrest-utils';
import Properties from '@wix/wixrest-properties';
import I18n from '@wix/wixrest-utils/dist/I18n';
import color from "color";
import _ from 'lodash';
import React from "react";

export class PolicyHelper
{
    constructor({isCustomDesign,contextStyles}){
        this.isCustomDesign=isCustomDesign
        this.contextStyles=contextStyles
    }

    getTextColor=()=>{
        const {colors}=this.contextStyles

        return this.isCustomDesign? colors['wixseating-field-txt-custom']: colors['wixseating-field-txt']

    }

    getBackgroundColor=()=>{
        const {colors}=this.contextStyles
        return this.isCustomDesign? colors['wixseating-field-fill-custom']:colors['wixseating-field-fill']
    }

    getLinkColor=()=>{
        const {contextStyles} =this

        return _.isEqual( (color(this.getBackgroundColor()).rgb()),(color(contextStyles.colors['color-8']).rgb()))
            ?
            this.getTextColor() :
            contextStyles.colors['color-8']
    }
    //
    // getDefinedTitleColor=()=>{
    //     const {isCustomDesign} =this
    //     const {colors}=this.contextStyles
    //     return isCustomDesign? colors['wixseating-title-color-custom']: colors['wixseating-title-color']
    //
    // }
    //
    // getTitleColor=()=>{
    //
    //     return color(this.getBackgroundColor()).rgb()===color(this.getDefinedTitleColor()).rgb()?this.getTextColor():this.getDefinedTitleColor()
    //
    //
    // }

    static getPolicyFromOrganization = (organization) => {
        // Trying to get policies from OPU first
        let policy = OPU.get(organization.reservations, Properties.Reservations.POLICIES, 'com.wix.restaurants');

        // If not there, check for previous implementation
        if (!policy) {
            const rawPolicy = _.get(organization, "reservations.properties.policy", '{}');
            policy = rawPolicy ? JSON.parse(rawPolicy) : {};
        }

        return Object.keys(policy).length > 0 ? policy : null;
    }

    static getPolicy = ({organization, onTextClickPrivacy, onTextClickTerm,biActions}) => {
        const policyBMSettings = PolicyHelper.getPolicyFromOrganization(organization)
        // const policyCheck=policyBMSettings && (checkout.policy? checkout.policy.policyCheckboxChecked:policyBMSettings.policyCheckbox && policyBMSettings.policyCheckbox.checkedByDefault !=='REQUIRED' )
        const policies = policyBMSettings && {
            showError: false,
            ...(policyBMSettings.termsAndConditions && {
                termsAndConditions: {
                    onClick: () =>
                    {
                        biActions.liveSiteOloConfirmationPageConsent({
                            appName:'reservations',
                            clickType:'terms',
                            consentDescription: policyBMSettings.termsAndConditions.type==='URL'?'url':'text'
                        })
                        policyBMSettings.termsAndConditions.type === 'URL' ? window.open(policyBMSettings.termsAndConditions.value) : onTextClickTerm()},
                    type: policyBMSettings.termsAndConditions.type,
                    value: policyBMSettings.termsAndConditions.value
                }
            }),
            ...(policyBMSettings.privacyPolicy && {
                privacyPolicy: {
                    onClick: () =>{
                        biActions.liveSiteOloConfirmationPageConsent({
                        appName:'reservations',
                        clickType:'privacy',
                        consentDescription: policyBMSettings.privacyPolicy.type==='URL'?'url':'text'
                    })
                        policyBMSettings.privacyPolicy.type === 'URL' ? window.open(policyBMSettings.privacyPolicy.value) : onTextClickPrivacy()},
                    type: policyBMSettings.privacyPolicy.type,
                    value: policyBMSettings.privacyPolicy.value
                }
            }),
            policyCheckbox: {
                isChecked: false,
                isShown: !!policyBMSettings.policyCheckbox,
                toggle: () => {

                    // checkoutActions.setPolicyCheckbox({
                    //    isChecked: checkout.policy?!checkout.policy.policyCheckboxChecked:true
                    // })
                }
            }
        }
        return policies
    }

     getPoliciesLink = (policy, description, key) => {


        return <span key={key} tabIndex={0}  style={{cursor: 'pointer', color: this.getLinkColor()}} onKeyPress={(event) => {
            if (event.key === 'Enter' || event.which === 32) {
                event.stopPropagation()
                policy.onClick()
            }
        }} onClick={(e) => {
            e.stopPropagation()
            policy.onClick()
        }}>
            {description}
        </span>
    }

     getPoliciesText = ({policyCheckbox, termsAndConditions, privacyPolicy}, ) => {
        const str = `${policyCheckbox.isShown}-${!!privacyPolicy}-${!!termsAndConditions}`
        const getText = () => {
            switch (str) {
                case 'true-true-true' : {
                    return this.getIAgreePrivacyAndTermsText(termsAndConditions, privacyPolicy, )
                }
                case 'true-false-true': {
                    return this.getIAgreeTermsAndConditionsText(termsAndConditions, )
                }
                case 'true-true-false': {
                    return this.getIAgreePrivacyText(privacyPolicy, )
                }
                case 'false-true-true' : {
                    return this.getPrivacyAndTermsNoCheckBoxText(termsAndConditions, privacyPolicy, )
                }
                case 'false-false-true': {
                    return this.getTermsAndCondNoCheckBoxText(termsAndConditions, )
                }
                case 'false-true-false': {
                    return this.getPrivacyNoCheckBoxText(privacyPolicy, )
                }

            }
        }
        return <div data-hook='policy-text' style={{position: 'relative', top: '-3px'}}>
            {getText()}
        </div>
    }
     getPrivacyAndTermsNoCheckBoxText = (termsAndConditions, privacyPolicy, ) => {

        return I18n.getWithNLink("1openrest_checkoutconfirmationview_policies_nocheckbox_termsandpolicy",
            "By placing your order, you agree to our ${link.begin}terms and conditions${link.end} and ${link.begin}privacy policy${link.end}",
            [description => this.getPoliciesLink(termsAndConditions, description, 'terms'), description => this.getPoliciesLink(privacyPolicy, description, 'privacy')]
        )
    }
     getPrivacyNoCheckBoxText = (privacyPolicy, ) => {

        return I18n.getWithLink("1openrest_checkoutconfirmationview_policies_nocheckbox_policy",
            "By placing your order, you agree to our ${link.begin}privacy policy${link.end}.",
            description => this.getPoliciesLink(privacyPolicy, description, 'privacy')
        )
    }

     getTermsAndCondNoCheckBoxText = (termsAndConditions, ) => {

        return I18n.getWithLink("1openrest_checkoutconfirmationview_policies_nocheckbox_terms",
            "By placing your order, you agree to our ${link.begin}terms and conditions${link.end}.",
            description => this.getPoliciesLink(termsAndConditions, description, 'terms')
        )
    }

     getIAgreePrivacyAndTermsText = (termsAndConditions, privacyPolicy, ) => {
        
        return I18n.getWithNLink("openrest_checkoutconfirmationview_policies_checkbox_termsandpolicy",
            "I agree to the ${link.begin}terms and conditions${link.end} and ${link.begin}privacy policy${link.end}.",
            [description => this.getPoliciesLink(termsAndConditions, description, 'terms'), description => this.getPoliciesLink(privacyPolicy, description, 'privacy')]
        )
    }

     getIAgreePrivacyText = (privacyPolicy, ) => {

        return I18n.getWithLink("openrest_checkoutconfirmationview_policies_checkbox_policy",
            "I agree to the ${link.begin}privacy policy${link.end}.",
            description => this.getPoliciesLink(privacyPolicy, description, 'privacy')
        )
    }
     getIAgreeTermsAndConditionsText = (termsAndConditions, ) => {

        return I18n.getWithLink("openrest_checkoutconfirmationview_policies_checkbox_terms",
            "I agree to the ${link.begin}terms and conditions${link.end}.",
            description => this.getPoliciesLink(termsAndConditions, description, 'terms')
        )
    }
}